export { useStorageValue, initializeStorage } from '@src/utils/storage/mmkv'
import { EhrCoachSpecialtyDef } from '@src/types'
import { clear, clearTokens, ensureTokensLoaded, get, remove, set } from '@src/utils/storage/mmkv'

const APP_VERSION_KEY = 'APP_VERSION'
const APP_FIRST_LOGIN_TIMESTAMP_KEY = 'APP_FIRST_LOGIN_TIMESTAMP'
const APP_OPEN_COUNT_KEY = 'APP_OPEN_COUNT'
const APP_CONSECUTIVE_USAGE_ON_DATE_KEY = 'APP_CONSECUTIVE_USAGE_ON_DATE'
const UNLEASH_STORAGE_KEY = 'UNLEASH_STORAGE'
const VISITED_TUTORIALS_KEY = 'VISITED_TUTORIALS'
const REPORTED_CHATBOT_MESSAGES_KEY = 'REPORTED_CHATBOT_MESSAGES'
const PERMISSIONS_MODAL_VISITED_KEY = 'PERMISSIONS_MODAL_VISITED'
const ONBOARDING_CHECKLIST_REMINDER_VISITED_KEY = 'ONBOARDING_CHECKLIST_REMINDER_VISITED'
const ONBOARDING_COACHING_KINDS_KEY = 'ONBOARDING_COACHING_KINDS'
const ONBOARDING_GOAL_KEY = 'ONBOARDING_GOAL'
const ONBOARDING_INSURANCE_PROVIDER_KEY = 'ONBOARDING_INSURANCE_PROVIDER'
const INSURANCE_QUESTIONNAIRE_VISITED_KEY = 'INSURANCE_QUESTIONNAIRE_VISITED'
const STELO_SYNC_DELAY_NOTICE_DISMISSED_KEY = 'STELO_SYNC_DELAY_NOTICE_DISMISSED'
const STELO_REALTIME_API_UPGRADE_MODAL_VISITED_KEY = 'STELO_REALTIME_API_UPGRADE_MODAL_VISITED'
const STELO_SENSOR_MIGRATION_NOTICE_VISITED_KEY = 'STELO_SENSOR_MIGRATION_NOTICE_VISITED'
const LAST_REVIEW_PROMPT_DATE_KEY = 'LAST_REVIEW_PROMPT_DATE'
const REVIEW_PROMPTS_COUNT_KEY = 'REVIEW_PROMPTS_COUNT'
const REVIEW_LEFT_KEY = 'REVIEW_LEFT'
const GLUCOSE_RECENT_KEY = 'GLUCOSE_RECENT'
const GOALS_QUESTIONNAIRE_MODAL_DISPLAY_COUNT_KEY = 'GOALS_QUESTIONNAIRE_MODAL_DISPLAY_COUNT'
const COURSES_ENGAGEMENT_PROMPT_CONFIG_KEY = 'COURSES_ENGAGEMENT_PROMPT_CONFIG'
const WALKTHROUGH_SHOWN_KEY = 'WALKTHROUGH_SHOWN'
const JOURNAL_ENGAGEMENT_PROMPT_CONFIG_KEY = 'JOURNAL_ENGAGEMENT_PROMPT_CONFIG'
const NO_ALLOTTED_CALLS_ALERT_CLOSED_KEY = 'NO_ALLOTED_CALLS_ALERT_CLOSED'
const CALL_SOON_ALERT_CLOSED_KEY = 'CALL_SOON_ALERT_CLOSED'
const MISSED_CALL_ALERT_CLOSED_KEY = 'MISSED_CALL_ALERT_CLOSED'
const NO_MORE_PAID_CALLS_ALERT_CLOSED_KEY = 'NO_MORE_PAID_CALLS_ALERT_CLOSED_KEY'
const CONNECT_HEALTH_PROVIDER_ALERT_CLOSED_KEY = 'CONNECT_HEALTH_PROVIDER_ALERT_CLOSED'
const HEALTH_PERMISSIONS_MODAL_VISITED_KEY = 'HEALTH_PERMISSIONS_MODAL_VISITED'
const DEXCOM_SENSOR_SWITCH_REJECTED_KEY = 'DEXCOM_SENSOR_SWITCH_REJECTED'

const CLAIM_FREE_VIDEO_CALL_MODAL_VISITED_KEY = 'CLAIM_FREE_VIDEO_CALL_MODAL_VISITED'
const EARLIER_APPOINTMENT_SLOT_AVAILABLE_MODAL_VISITED_KEY =
  'EARLIER_APPOINTMENT_SLOT_AVAILABLE_MODAL_VISITED'
const INSURANCE_POLICY_REJECTED_MODAL_VISITED_KEY = 'INSURANCE_POLICY_REJECTED_MODAL_VISITED'
const NUTRITIONIST_HUB_RED_DOT = 'NUTRITIONIST_HUB_RED_DOT'
const UPGRADE_SUBSCRIPTION_BANNER_VISITED_KEY = 'UPGRADE_SUBSCRIPTION_BANNER_VISITED'
const VIDEO_CALLS_UPSELL_MODAL_VISITED_COUNT_KEY = 'VIDEO_CALLS_UPSELL_MODAL_VISITED_COUNT'
const VIDEO_CALLS_UPSELL_MODAL_VISITED_RECENT_SUBSCRIPTION =
  'VIDEO_CALLS_UPSELL_MODAL_VISITED_RECENT_SUBSCRIPTION'
const VIDEO_CALLS_STELO_UPSELL_MODAL_VISITED_KEY = 'VIDEO_CALLS_STELO_UPSELL_MODAL_VISITED_KEY'
const VIDEO_CALLS_STELO_UPSELL_REFERRAL_MODAL_VISITED_KEY =
  'VIDEO_CALLS_STELO_UPSELL_REFERRAL_MODAL_VISITED_KEY'
const VIDEO_CALLS_UPSELL_MODAL_COMPLETED_KEY = 'VIDEO_CALLS_UPSELL_MODAL_COMPLETED'
const VIDEO_CALL_CHECK_IN_COMPLETED_KEY = 'VIDEO_CALL_CHECK_IN_COMPLETED'
const VIDEO_CALL_FEE_IDEMPOTENCY_KEY = 'VIDEO_CALL_FEE_IDEMPOTENCY_KEY'
const ONBOARDING_SENSOR_TYPE_SELECTED_KEY = 'ONBOARDING_SENSOR_TYPE_SELECTED'
const ONBOARDING_FLOW_TYPE_SELECTED_KEY = 'ONBOARDING_FLOW_TYPE_SELECTED'
const VIDEO_CALL_DATA_KEY = 'VIDEO_CALL_DATA'
const COACH_RATING_DISMISSED_KEY = 'COACH_RATING_DISMISSED_KEY'
const LAST_COACH_RATING_KEY = 'LAST_COACH_RATING'
const BYOS_VIDEO_CALLS_UPSELL_LAST_STEP_KEY = 'BYOS_VIDEO_CALLS_UPSELL_LAST_STEP'
const BYOS_VIDEO_CALLS_UPSELL_LAST_INTERACTION_TIMESTAMP_KEY =
  'BYOS_VIDEO_CALLS_UPSELL_LAST_INTERACTION_TIMESTAMP'
const OWN_SENSOR_ACTIVATED_VIDEO_CALL_UPSELL_MODAL_COMPLETED_KEY =
  'OWN_SENSOR_ACTIVATED_VIDEO_CALL_UPSELL_MODAL_SHOWN'
const WEIGHT_LOSS_EXPERIENCE_ONBOARDING_KEY = 'WEIGHT_LOSS_EXPERIENCE_ONBOARDING_KEY'
const WEIGHT_LOSS_EXPERIENCE_VISIT_PLAN_DETAILS_KEY =
  'WEIGHT_LOSS_EXPERIENCE_VISIT_PLAN_DETAILS_KEY'
const WEIGHT_LOSS_GOALS_INFO_HIDDEN_AT_KEY = 'WEIGHT_LOSS_GOALS_INFO_HIDDEN_AT'
const MFA_TOKEN = 'MFA_TOKEN'
const DAILY_ACTION_STREAK_COMPLETED_SHOWN_AT_KEY = 'DAILY_ACTION_STREAK_COMPLETED_SHOWN_AT'
const DAILY_ACTION_COMPLETED_ACTIONS_KEY = 'DAILY_ACTION_COMPLETED_ACTIONS'
const HEALTH_CONNECT_LATEST_ATTEMPTED_SYNC_TIMESTAMP_KEY =
  'HEALTH_CONNECT_LATEST_ATTEMPTED_SYNC_TIMESTAMP_KEY'
const HEALTH_CONNECT_LATEST_SYNC_TIMESTAMP_KEY = 'HEALTH_CONNECT_LATEST_SYNC_TIMESTAMP_KEY'
const NOTIFICATION_TOKEN_REGISTERED_AT_KEY = 'NOTIFICATION_TOKEN_REGISTERED_AT'
const FIRST_CALL_BANNER_GOALS_QUESTIONNAIRE_TAPPED_KEY =
  'FIRST_CALL_BANNER_GOALS_QUESTIONNAIRE_TAPPED_KEY'

const UHC_SUBSCRIPTION_EXPIRED_MODAL_CLOSED_KEY = 'UHC_SUBSCRIPTION_EXPIRED_MODAL_CLOSED_KEY'
const REFERRAL_BANNER_SHOWN_AT_KEY = 'REFERRAL_BANNER_SHOWN_AT_KEY'
const USED_MEAL_LOG_VOICE_KEY = 'USED_MEAL_LOG_VOICE_KEY'
const FREE_CALL_TRIAL_UPSELL_BANNER_SHOWN_AT_KEY = 'FREE_CALL_TRIAL_UPSELL_BANNER_SHOWN_AT_KEY'
const STREAM_CHAT_TOKEN_KEY = 'STREAM_CHAT_TOKEN'
const STREAM_CHAT_TOKEN_EXPIRE_AT_KEY = 'STREAM_CHAT_TOKEN_EXPIRE_AT'
const NORA_PIN_CONVERSATION_TOOLTIP_SHOWN_KEY = 'NORA_PIN_CONVERSATION_TOOLTIP_SHOWN'

export interface VideoCallData {
  meetingAt: string
  coachFullName: string
  coachPhoto?: string | null
  coachCredentials?: string | null
  coachBio?: string | null
  coachSpecialties: Pick<EhrCoachSpecialtyDef, 'key' | 'name'>[]
  coachId: string
  coachUserId: string
  referringUserId?: string
}

export default {
  get,
  set,
  remove,
  clear,
  clearTokens,
  ensureTokensLoaded,
  APP_FIRST_LOGIN_TIMESTAMP_KEY,
  APP_OPEN_COUNT_KEY,
  APP_VERSION_KEY,
  APP_CONSECUTIVE_USAGE_ON_DATE_KEY,
  CALL_SOON_ALERT_CLOSED_KEY,
  MISSED_CALL_ALERT_CLOSED_KEY,
  NO_MORE_PAID_CALLS_ALERT_CLOSED_KEY,
  CLAIM_FREE_VIDEO_CALL_MODAL_VISITED_KEY,
  COACH_RATING_DISMISSED_KEY,
  LAST_COACH_RATING_KEY,
  CONNECT_HEALTH_PROVIDER_ALERT_CLOSED_KEY,
  COURSES_ENGAGEMENT_PROMPT_CONFIG_KEY,
  DEXCOM_SENSOR_SWITCH_REJECTED_KEY,
  EARLIER_APPOINTMENT_SLOT_AVAILABLE_MODAL_VISITED_KEY,
  GLUCOSE_RECENT_KEY,
  GOALS_QUESTIONNAIRE_MODAL_DISPLAY_COUNT_KEY,
  INSURANCE_POLICY_REJECTED_MODAL_VISITED_KEY,
  HEALTH_PERMISSIONS_MODAL_VISITED_KEY,
  JOURNAL_ENGAGEMENT_PROMPT_CONFIG_KEY,
  LAST_REVIEW_PROMPT_DATE_KEY,
  NUTRITIONIST_HUB_RED_DOT,
  NO_ALLOTTED_CALLS_ALERT_CLOSED_KEY,
  ONBOARDING_CHECKLIST_REMINDER_VISITED_KEY,
  ONBOARDING_COACHING_KINDS_KEY,
  ONBOARDING_GOAL_KEY,
  ONBOARDING_INSURANCE_PROVIDER_KEY,
  INSURANCE_QUESTIONNAIRE_VISITED_KEY,
  PERMISSIONS_MODAL_VISITED_KEY,
  REVIEW_LEFT_KEY,
  REVIEW_PROMPTS_COUNT_KEY,
  STELO_REALTIME_API_UPGRADE_MODAL_VISITED_KEY,
  STELO_SENSOR_MIGRATION_NOTICE_VISITED_KEY,
  STELO_SYNC_DELAY_NOTICE_DISMISSED_KEY,
  UNLEASH_STORAGE_KEY,
  UPGRADE_SUBSCRIPTION_BANNER_VISITED_KEY,
  VIDEO_CALLS_UPSELL_MODAL_COMPLETED_KEY,
  VIDEO_CALLS_UPSELL_MODAL_VISITED_COUNT_KEY,
  VIDEO_CALLS_STELO_UPSELL_MODAL_VISITED_KEY,
  VIDEO_CALLS_STELO_UPSELL_REFERRAL_MODAL_VISITED_KEY,
  VIDEO_CALLS_UPSELL_MODAL_VISITED_RECENT_SUBSCRIPTION,
  VIDEO_CALL_CHECK_IN_COMPLETED_KEY,
  VIDEO_CALL_FEE_IDEMPOTENCY_KEY,
  VISITED_TUTORIALS_KEY,
  REPORTED_CHATBOT_MESSAGES_KEY,
  WALKTHROUGH_SHOWN_KEY,
  ONBOARDING_SENSOR_TYPE_SELECTED_KEY,
  ONBOARDING_FLOW_TYPE_SELECTED_KEY,
  VIDEO_CALL_DATA_KEY,
  BYOS_VIDEO_CALLS_UPSELL_LAST_STEP_KEY,
  BYOS_VIDEO_CALLS_UPSELL_LAST_INTERACTION_TIMESTAMP_KEY,
  OWN_SENSOR_ACTIVATED_VIDEO_CALL_UPSELL_MODAL_COMPLETED_KEY,
  WEIGHT_LOSS_EXPERIENCE_ONBOARDING_KEY,
  WEIGHT_LOSS_EXPERIENCE_VISIT_PLAN_DETAILS_KEY,
  WEIGHT_LOSS_GOALS_INFO_HIDDEN_AT_KEY,
  MFA_TOKEN,
  DAILY_ACTION_STREAK_COMPLETED_SHOWN_AT_KEY,
  DAILY_ACTION_COMPLETED_ACTIONS_KEY,
  HEALTH_CONNECT_LATEST_ATTEMPTED_SYNC_TIMESTAMP_KEY,
  HEALTH_CONNECT_LATEST_SYNC_TIMESTAMP_KEY,
  NOTIFICATION_TOKEN_REGISTERED_AT_KEY,
  UHC_SUBSCRIPTION_EXPIRED_MODAL_CLOSED_KEY,
  REFERRAL_BANNER_SHOWN_AT_KEY,
  USED_MEAL_LOG_VOICE_KEY,
  FREE_CALL_TRIAL_UPSELL_BANNER_SHOWN_AT_KEY,
  STREAM_CHAT_TOKEN_KEY,
  STREAM_CHAT_TOKEN_EXPIRE_AT_KEY,
  NORA_PIN_CONVERSATION_TOOLTIP_SHOWN_KEY,
  FIRST_CALL_BANNER_GOALS_QUESTIONNAIRE_TAPPED_KEY,
}
